import { render, staticRenderFns } from "./TrainingLayout.vue?vue&type=template&id=7a90beb6&scoped=true&"
import script from "./TrainingLayout.vue?vue&type=script&lang=js&"
export * from "./TrainingLayout.vue?vue&type=script&lang=js&"
import style0 from "./TrainingLayout.vue?vue&type=style&index=0&id=7a90beb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a90beb6",
  null
  
)

export default component.exports